import React from 'react'
import { FaLinkedinIn, FaReact, FaAngular } from "react-icons/fa";
import { SiDjango, SiFlutter, SiGithub, SiGmail, SiDocker } from "react-icons/si";
const Media = () => {
  return (
    <div className="flex flex-col xl:flex-row gap-6 lgl:gap-0 justify-between">
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          Find me on
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <a href="https://github.com/igornovic21" target="_blank" rel="noopener noreferrer">
              <SiGithub />
              </a>
          </span>
          <span className="bannerIcon">
            <a href="mailto:kamaguefokoigor@gmail.com">
              <SiGmail />
              </a>
          </span>
          <span className="bannerIcon">
            <a href="https://www.linkedin.com/in/igor-kamgue-foko-593207184/" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
              </a>
          </span>
        </div>
      </div>
      <div>
        <h2 className="text-base uppercase font-titleFont mb-4">
          BEST STACK
        </h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <SiDjango />
          </span>
          <span className="bannerIcon">
            <SiFlutter />
          </span>
          <span className="bannerIcon">
            <FaReact />
          </span>
          <span className="bannerIcon">
            <FaAngular />
          </span>
          <span className="bannerIcon">
            <SiDocker />
          </span>
        </div>
      </div>
    </div>
  )
}

export default Media